import React from 'react';
import { ChartContainer, SizeVariant } from './Chart.styles';
import { getGradientColoursByScore } from '../../../utils/getGradientColoursByScore';

interface Props {
  size?: SizeVariant;
  score?: number;
}

export const Chart: React.FC<Props> = ({ size = 'medium', score, children }) => {
  const { base, highlight } = getGradientColoursByScore(score);

  return (
    <ChartContainer
      size={size}
      style={{
        background: `linear-gradient(90deg, ${base} 0%, ${highlight} 50%, ${base} 100%)`,
      }}
    >
      {children}
    </ChartContainer>
  );
};
